<div class="flex min-h-screen flex-col bg-slate-50 text-slate-900">
  <app-header />

  <main class="flex-1" [class.pt-20]="!isHomePage">
    <router-outlet />
  </main>

  <app-footer />
  <app-offline-indicator />
</div>

@if (hasFatalError()) {
  <div class="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 px-4">
    <div class="w-full max-w-sm rounded-2xl bg-white p-8 text-center shadow-2xl">
      <div class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-rose-100">
        <svg class="h-7 w-7 text-rose-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
        </svg>
      </div>
      <h2 class="text-lg font-bold text-slate-900">Something went wrong</h2>
      <p class="mt-2 text-sm text-slate-500">An unexpected error occurred. Reload the page to continue.</p>
      <button
        type="button"
        (click)="reloadPage()"
        class="mt-6 w-full rounded-xl bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-indigo-500">
        Reload page
      </button>
    </div>
  </div>
}
